const MAIN_PATH = '/settings';
export const SETTINGS_PATH = `${MAIN_PATH}`;
export const DOCUMENTS_SETTINGS_PATH = `${MAIN_PATH}/documents`;
export const THEME_SETTINGS_PATH = `${MAIN_PATH}/theme`;
export const PAYMENT_METHODS_PATH = `${MAIN_PATH}/payment-methods`;
export const TICKET_BAI_PATH = `${MAIN_PATH}/ticket-bai`;
export const VERIFACTU_PATH = `${MAIN_PATH}/verifactu`;
export const OTHER = `${MAIN_PATH}/other`;
